<!-- @format -->

<app-top-menu></app-top-menu>

<div class="container">
	<div class="spacer"></div>
	<div class="bg-white p-4 mb-4">
		<form [formGroup]="form">
			<div class="row m-mobile">
				<div class="col-md-6 col-xs-12 col-sm-12 mb-3">
					<div class="input-group-div">
						<label class="required">Verification Type</label>
						<select formControlName="verificationType">
							<option value="">-- Select Type--</option>
							<option value="annualReturnCertificate">
								Annual Return Receipt/Certificate
							</option>
							<option value="assessmentReceipt">
								Assessment Receipt / Certificate
							</option>
							<option value="payeTcc">PAYE TCC</option>
							<option value="paymentReceipt">
								Payment Receipt
							</option>
							<option value="stamp_duty">
								Stamp Duty Certificate
							</option>
							<option value="cgt">
								Capital Gain Tax Certificate
							</option>
							<option value="tcc">
								Tax Clearance Certificate
							</option>
							<option value="wht">Withholding Tax</option>
							<option value="vaids">
								VAIDS Acknowledgement / Certificate
							</option>
						</select>
					</div>
				</div>

				<div class="col-md-4 col-xs-12 col-sm-12 mb-3">
					<div class="input-group-div">
						<label class="required">ID.</label>
						<input
							type="text"
							formControlName="id"
							placeholder="Enter ID: #### - ##########"
						/>
					</div>
				</div>

				<div class="col-md-2 col-xs-12 col-sm-12">
					<button
						type="submit"
						class="verify-button"
						[disabled]="!form.valid"
						(click)="verify()"
					>
						Verify
					</button>
				</div>
			</div>
		</form>
	</div>
</div>

<div style="height: 820px"></div>

<div style="position: sticky; bottom: 0">
	<app-footer class="m-hidden"></app-footer>
</div>
